import styled from "styled-components";

const StarPercentage = styled.rect<{ stars: number }>`
  height: 100%;
  width: ${({ stars }) => stars * 20}%;
  transition: width 0.25s;
`;

export default StarPercentage;